import { useEffect, useState } from 'react'
import { Container, Typography, Box } from '@mui/material'
import { getQuizStats } from '../services/Common/quiz.service'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function QuizStatsPage(){
  const { id } = useParams()
  const [stats, setStats] = useState(null)

  useEffect(()=>{ if(id) (async ()=>{ try{ const data = await getQuizStats(id); setStats(data) }catch(e){console.error(e); toast.error('Failed to load stats')} })() }, [id])

  if(!stats) return null

  return (
    <Container>
      <Typography variant='h4'>Quiz Stats</Typography>
      <Box mt={2}>
        <Typography>Total Attempts: {stats.totalAttempts}</Typography>
        <Typography>Average Score: {stats.avgScore}%</Typography>
        <Typography>Distribution: {stats.distribution.join(', ')}</Typography>
      </Box>
    </Container>
  )
}
